import { FormFieldActionTypes, useForm } from '@frontend/design-system';

const MIN_AMOUNT = 0.5;
interface PatientDetailsFormHook {
  requestedAmount?: number;
  onFocus?: () => void;
}

export const usePatientDetailsForm = ({ requestedAmount, onFocus }: PatientDetailsFormHook) => {
  const form = useForm({
    fields: {
      firstName: {
        type: 'text',
        required: true,
      },
      lastName: {
        type: 'text',
        required: true,
      },
      amount: {
        type: 'money',
        required: true,
        value: requestedAmount?.toString() ?? '',
        min: MIN_AMOUNT,
        max: requestedAmount ?? Infinity,
      },
    },
    fieldStateReducer: (state, action) => {
      if (action.type === FormFieldActionTypes.Focus) {
        onFocus?.();
      }
      return {
        ...state,
      };
    },
  });

  return form;
};
